import { CloseIcon, Tooltip } from '@acceso/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusSeenChipSelect } from '@/components/StatusSeenChipSelect';
import { SEGMENT_REVIEW_STATES } from '@/constants';
import { TClip } from '@/features/clips/types';
import { TReviewStateValues } from '@/features/segments/types';

type TCutsManagementBarProps = {
  selectedItems: TClip[];
  onClearSelection: () => void;
  onBatchUpdateStatus: (reviewState: TReviewStateValues) => void;
  isLoading: boolean;
};

export function BroadcastScheduleProgramBodySegmentToolkitCutsManagementBar({
  selectedItems,
  onClearSelection,
  onBatchUpdateStatus,
  isLoading,
}: TCutsManagementBarProps) {
  const { t } = useTranslation();

  const commonReviewState = useMemo<number | null>(() => {
    if (selectedItems.length === 0) return null;
    const first = selectedItems[0].review_state;
    return selectedItems.every(item => item.review_state === first) ? first : null;
  }, [selectedItems]);

  const handleChangeStatus = (value: string) => {
    onBatchUpdateStatus(parseInt(value) as TReviewStateValues);
  };

  return (
    <div className="flex items-center justify-end gap-3 px-4 py-2">
      <span className="text-sm font-medium text-blue-700">
        {`${selectedItems.length} ${t('cortes seleccionados')}`}
      </span>

      <div className={isLoading ? 'pointer-events-none opacity-50' : undefined}>
        <StatusSeenChipSelect
          value={commonReviewState}
          onChange={handleChangeStatus}
          reviewStates={SEGMENT_REVIEW_STATES}
          buttonClassName="!w-40"
        />
      </div>

      <Tooltip help={t('Deseleccionar todo')}>
        <button
          type="button"
          onClick={onClearSelection}
          className="ml-auto cursor-pointer text-blue-500 hover:text-blue-700"
          aria-label={t('Deseleccionar todo')}
        >
          <CloseIcon />
        </button>
      </Tooltip>
    </div>
  );
}
